import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faPlus } from '@fortawesome/free-solid-svg-icons';
import NotificationHistory from './NotificationHistory';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import { toast } from 'react-toastify';

class PushNotification extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            enabled: true,
            daysBefore: 1,
            messageContent: '',
            isPushNotification: true,
            emailSubjectValue: '',

            // VARIABLES TO display notification history
            isShowNotificationHistory: false,

            pushSettingDataList: [],
            totalPushSetting: 0,

            addParameterValues: [
                { name: "Resource_Title", value: 'Resource_Title' },
                { name: "accession_series", value: 'accession_series' },
                { name: "accession_number", value: 'accession_number' },
                { name: "Resource_Author", value: 'Resource_Author' },
                { name: "User_Role", value: 'User_Role' },
                { name: "User_first_Name", value: 'User_first_Name' },
                { name: "User_Last_Name", value: 'User_Last_Name' },
                { name: "Issued_Date", value: 'Issued_Date' },
                { name: "Due_Date", value: 'Due_Date' },
                { name: "Fine_Per_Day", value: 'Fine_Per_Day' },
                { name: "Applicable_Fine", value: 'Applicable_Fine' },
                { name: "College_Name", value: 'College_Name' }
            ],
        };
    }

    componentDidMount() {
        this.apiCallToGetPushNotificationData();
    }

    // API CALL TO GET Push notification DATA LIST
    apiCallToGetPushNotificationData = async () => {
        let requestData = {
            "iid": config.institute_id,
            "type": "mobileNotification"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetSmtpNotification',
            requestData,
            "/api/library/librarySmtpNotificationSetting.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetPushNotificationData();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (Object.values(apiResult?.data)?.length > 0) {
                    if (apiResult.success == 'true') {
                        const notificationData = Object.values(apiResult.data)[0];

                        this.setState({
                            pushSettingDataList: apiResult.data,
                            totalPushSetting: apiResult.totalCount,
                        })

                        this.setState({
                            isPushNotification: notificationData.access === "true" ? true : false,
                            daysBefore: Number(notificationData.days),
                            messageContent: notificationData.emailText,
                            emailSubjectValue: notificationData.emailSubject
                        })
                    }
                    else {
                        this.setState({
                            pushSettingDataList: [],
                            totalPushSetting: 0,
                        })
                    }
                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.setState({
                        pushSettingDataList: [],
                        totalPushSetting: 0,
                    })
                    this.setState({
                        isPushNotification: true,
                        daysBefore: 1,
                        messageContent: ''
                    })
                }
            } else {
                this.setState({
                    pushSettingDataList: [],
                    totalPushSetting: 0,
                })
            }
        }
    }


    handleToggle = () => {
        this.setState(prevState => ({
            enabled: !prevState.enabled
        }));
    };

    handleDaysChange = (event) => {
        this.setState({ daysBefore: event.target.value });
    };

    handleToggleStatus = (isPushNotification) => {
        this.setState({ isPushNotification: !isPushNotification });
    }

    handleContentChange = (messageContent) => {
        this.setState({ messageContent: messageContent.target.value })
    }

    // close modal for notification history
    closeModalForNotificationHistory = () => {
        this.setState({
            isShowNotificationHistory: false
        })
    }

    // add mobileNotification notification
    library_AddSmtpNotification = async () => {
        let requestData = {
            "iid": config.institute_id,
            "type": "mobileNotification",
            "access": this.state.isPushNotification ? "true" : "false",
            "days": Number(this.state.daysBefore),
            "emailText": this.state.messageContent,
            "addedBy": config.faculty_id,
            "emailSubject": this.state.emailSubjectValue,
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_AddSmtpNotification',
            requestData,
            "/api/library/librarySmtpNotificationSetting.php"
        )

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.library_AddSmtpNotification();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == "success") {

                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.apiCallToGetPushNotificationData();

                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error('Something went wrong while getting mobile configuration setting. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    // update mobileNotification notification
    library_UpdateSmtpNotification = async () => {
        let requestData = {
            "iid": config.institute_id,
            "access": this.state.isPushNotification ? "true" : "false",
            "days": Number(this.state.daysBefore),
            "emailText": this.state.messageContent,
            "emailSubject": this.state.emailSubjectValue,
            "updatedBy": config.faculty_id,
            "uniqueId": Object.values(this.state.pushSettingDataList)[0].uniqueId
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_UpdateSmtpNotification',
            requestData,
            "/api/library/librarySmtpNotificationSetting.php"
        )

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.library_UpdateSmtpNotification();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == "success") {

                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.apiCallToGetPushNotificationData();

                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error('Something went wrong while getting mobile configuration setting. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    handleOnClick = () => {
        if (Object.values(this.state.pushSettingDataList).length === 0) {
            this.library_AddSmtpNotification()
        } else {
            this.library_UpdateSmtpNotification()
        }
    }

    // METHOD TO ADD PARAMETER
    addParameter = (parameter) => {
        let { messageContent } = this.state;
        let updatedMessage = messageContent + ` {${parameter}}`;
        this.setState({
            messageContent: updatedMessage
        });
    }

    isFormValid = () => {
        const {
            isPushNotification,
            daysBefore,
            messageContent,
            emailSubjectValue
        } = this.state;

        if (!isPushNotification) return true;

        return (
            String(daysBefore).trim() !== '' &&
            String(messageContent).trim() !== '' &&
            String(emailSubjectValue).trim() !== ''
        );
    };

    render() {

        return (
            <>
                <div className="notification-container">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center d-flex-with-gap">
                            <span className="textHeadingLabel me-3">Enable /Disable Push Notification</span>
                            <span
                                onClick={() => this.handleToggleStatus(this.state.isPushNotification)}
                                style={{
                                    display: 'inline-block',
                                    width: '30px',
                                    height: '16px',
                                    borderRadius: '9.5px',
                                    backgroundColor: this.state.isPushNotification ? '#0465ac' : 'grey',
                                    position: 'relative',
                                    cursor: 'pointer',
                                }}
                            >
                                <span
                                    style={{
                                        display: 'block',
                                        width: '10px',
                                        height: '10px',
                                        borderRadius: '50%',
                                        backgroundColor: '#fff',
                                        position: 'absolute',
                                        top: '3px',
                                        left: this.state.isPushNotification ? '16px' : '1px',
                                        transition: 'left 0.3s ease',
                                    }}
                                ></span>
                            </span>
                        </div>

                        <button className="btn btn-outline btn-sm custom-button" onClick={() => {
                            this.setState({
                                isShowNotificationHistory: true
                            });
                        }}>
                            <FontAwesomeIcon icon={faClock} className="me-1 mr-2" />
                            Notification Logs
                        </button>
                    </div>

                    <div className="custom-boarder-width mt-4">
                        <span className="stepsNotificationLabel">Steps to set up Push Notification</span>
                        <ul className="mt-2 ml-2 p-2">
                            <li className="textHeadingLabel mb-2">
                                This is the default notification template. If you need to make changes, you can update the template below.
                            </li>
                            <li className="textHeadingLabel">
                                This notification will be triggered
                                <select
                                    className="form-select form-select-sm custom-select w-auto mx-2"
                                    value={this.state.daysBefore}
                                    onChange={this.handleDaysChange}
                                >
                                    <option value={1}>1 Day</option>
                                    <option value={2}>2 Days</option>
                                    <option value={3}>3 Days</option>
                                </select>
                                before due date.
                            </li>
                        </ul>
                    </div>

                    <div className="custom-boarder-width mt-3">
                        <div className="col-md-3 d-flex flex-column" style={{ padding: "inherit" }}>
                            <label className="custom-label mb-1">Push Notification Title</label>
                            <input
                                type="text"
                                className={`custom-inputField form-control`}
                                placeholder="Enter Push Notification Title"
                                value={this.state.emailSubjectValue}
                                onChange={(e) => {
                                    this.setState({ emailSubjectValue: e.target.value });
                                }}
                            />
                            {this.state.isPushNotification && !this.state.emailSubjectValue && (
                                <div className="invalid-feedback d-block text-start mt-1" style={{ color: '#dc3545' }}>
                                    Push Notification Title is required.
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="custom-boarder-width mt-3">
                        <div className='d-flex justify-content-between align-items-center'>
                            <div>
                                <label className="form-label">Message Content</label>
                            </div>
                            <div>
                                <div className="d-flex justify-content-end mb-1">
                                    <button
                                        className="btn btn-outline btn-sm custom-button"
                                        id='orderByDropdownMenu'
                                        data-toggle="dropdown"
                                        aria-expanded="false"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                    >
                                        <FontAwesomeIcon icon={faPlus} className="me-1 mr-2" />
                                        Add Parameters
                                    </button>
                                    <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='orderByDropdownMenu'>
                                        <div id='addParameterDropdown'>
                                            {
                                                this.state.addParameterValues.map((columnInfo, index) => {
                                                    const isSelected = this.state.isOrderByResourcesValue === columnInfo.value;
                                                    return (
                                                        <p
                                                            key={columnInfo.name}
                                                            className="dropdown-item"
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                fontSize: '14px',
                                                                backgroundColor: isSelected ? '#e0f7fa' : 'transparent',
                                                                color: isSelected ? '#0465AC' : 'black',
                                                                cursor: 'pointer',
                                                                padding: '10px'
                                                            }}
                                                            onClick={() => this.addParameter(columnInfo.name)}
                                                        >
                                                            <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                        </p>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Textarea */}
                        <textarea
                            className={`form-control`}
                            rows="5"
                            maxLength={250}
                            placeholder="Enter Message content here"
                            value={this.state.messageContent}
                            onChange={this.handleContentChange}
                        />

                        {/* Validation message */}
                        {this.state.isPushNotification && !this.state.messageContent && (
                            <div className="invalid-feedback d-block text-start mt-1" style={{ color: '#dc3545' }}>
                                Message Content is required.
                            </div>
                        )}

                        <div className="d-flex justify-content-end">
                            <small className="text-muted mt-1">Max 250 characters are allowed.</small>
                        </div>
                    </div>

                    <div className="custom-boarder-width mt-4">
                        {/* Save Button */}
                        <div className="mt-4">
                            <button className="btn btn-primary" onClick={() => { this.handleOnClick() }} disabled={!this.isFormValid()}>Save</button>
                        </div>
                    </div>
                </div>

                {
                    <NotificationHistory
                        isShowNotificationHistory={this.state.isShowNotificationHistory}
                        closeModalForNotificationHistory={this.closeModalForNotificationHistory}
                        headerName={"Push"}
                        type="mobileNotification"
                    />
                }
            </>
        )
    }
}

export default PushNotification;